import Header from "../components/Header";
import Hero from "../components/Hero";

type Props = {};

function LandingPage({}: Props) {
  return (
    <div>
      <Header />
      <Hero />
    </div>
  );
}

export default LandingPage;
